import React from "react";
import { TabHeaderView } from "./view";
import { styles } from "./styles";

export class TabHeader extends React.Component {
  render() {
    return <TabHeaderView {...this.props} styles={styles} />;
  }
}
